/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Memberssince1Inputs */

const en_memberssince1 = /** @type {(inputs: Memberssince1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Member since ${i?.date}`)
};

const de_memberssince1 = /** @type {(inputs: Memberssince1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mitglied seit ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Member since {date}" |
*
* @param {Memberssince1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const memberssince1 = /** @type {((inputs: Memberssince1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memberssince1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_memberssince1(inputs)
	return de_memberssince1(inputs)
});
export { memberssince1 as "membersSince" }